import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './Banner.module.css';

const Banner = props => {
  const { className, header, body, ...rest } = props;

  const classes = classNames(css.root, className);

  return (
    <div className={classes} {...rest}>
      {header && <div className={css.header}>{header}</div>}
      {body && <div className={css.body}>{body}</div>}
    </div>
  );
};

Banner.defaultProps = {
  className: null,
  header: null,
  body: null,
};

Banner.propTypes = {
  className: string,
  header: string,
  body: string,
};

export default Banner;
